module.exports = __webpack_public_path__ + "img/loader.9d23a45a.png";